import { render, staticRenderFns } from "./SpatialSpanColorSequence.vue?vue&type=template&id=726cac22&scoped=true&"
import script from "./SpatialSpanColorSequence.vue?vue&type=script&lang=js&"
export * from "./SpatialSpanColorSequence.vue?vue&type=script&lang=js&"
import style0 from "./SpatialSpanColorSequence.vue?vue&type=style&index=0&id=726cac22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726cac22",
  null
  
)

export default component.exports